import HSuiteApiService from '@/core/services/hsuiteApi.service'

async function GetQwilrDefinitions() {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitions`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionsByFilter(filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionsByFilter`,`?filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionFields(qwilrDefinitionId=null,isKey=null) {
  let result = null;
  let params=''

  params=`?qwilrDefinitionId=${qwilrDefinitionId}&isKey=${isKey}`
  if(isKey==null){
    params=`?qwilrDefinitionId=${qwilrDefinitionId}`
  }
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionFields`,params).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionKeyFieldsQueryModel(qwilrDefinitionId=null) {
  let result = null;
  let params=''

  params=`?qwilrDefinitionId=${qwilrDefinitionId}`
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionKeyFieldsQueryModel`, params).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionFieldsByFilter(filter="",qwilrDefinitionId=null,isKey=null,pageSize,pageIndex) {
  let result = null;
  let params=''
  if(isKey){
    params=`?filter=${filter}&qwilrDefinitionId=${qwilrDefinitionId}&isKey=${isKey}&pageSize=${pageSize}&pageIndex=${pageIndex}`
  }else{
    params=`?filter=${filter}&qwilrDefinitionId=${qwilrDefinitionId}&pageSize=${pageSize}&pageIndex=${pageIndex}`
  }
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionFieldsByFilter`,params).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionById(templateId) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionById/`+templateId).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionElements(qwilrDefinitionId,isBlock) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionElements`,`?qwilrDefinitionId=${qwilrDefinitionId}&isBlock=${isBlock}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrDefinitionElementsByFilter(qwilrDefinitionId,elementType,filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDefinitionElementsByFilter`,`?qwilrDefinitionId=${qwilrDefinitionId}&elementType=${elementType}&filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetBlocksFromQwilrApi() {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetBlocksFromQwilrApi`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function AddQwilrDefinitionElement(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddQwilrDefinitionElement`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function DeleteQwilrDefinitionElement(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/DeleteQwilrDefinitionElement`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateQwilrDefinitionElement(data) {
  let result = null;
  await HSuiteApiService.put(`/api/Qwilr/UpdateQwilrDefinitionElement`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetQwilrSubstitutionMappings(qwilrDefinitionElementId,filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrSubstitutionMappings`,`?qwilrDefinitionElementId=${qwilrDefinitionElementId}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function GetQwilrSubstitutionMappingsByFilter(qwilrDefinitionElementId,filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrSubstitutionMappingsByFilter`,`?qwilrDefinitionElementId=${qwilrDefinitionElementId}&filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function AddQwilrSubstitutionMapping(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddQwilrSubstitutionMapping`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function DeleteQwilrSubstitutionMapping(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/DeleteQwilrSubstitutionMapping`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateQwilrSubstitutionMapping(data) {
  let result = null;
  await HSuiteApiService.put(`/api/Qwilr/UpdateQwilrSubstitutionMapping`, data).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function CreateQwilrPage(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/CreateQwilrPage`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetQwilrPagesByFilter(keyFieldValue,filter="",pageSize,pageIndex) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrPagesByFilter`,`?keyFieldValue=${keyFieldValue}&filter=${filter}&pageSize=${pageSize}&pageIndex=${pageIndex}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function DeleteQwilrPage(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/DeleteQwilrPage`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function AddQwilrQueryBuilder(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddQwilrQueryBuilder`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetQwilrQueryBuilderById(queryId) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrQueryBuilderById/`+queryId).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function AddKeyFieldFromSqlParameter(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddKeyFieldFromSqlParameter`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function AddContentFieldFormQuery(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddContentFieldFormQuery`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function AddQwilrDefinitionField(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddQwilrDefinitionField`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function DeleteQwilrDefinitionFieldById(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/DeleteQwilrDefinitionFieldById`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateQwilrDefinitionField(payLoad) {
  let result = null;
  await HSuiteApiService.put(`/api/Qwilr/UpdateQwilrDefinitionField`, payLoad).then(response => {
    result = response;
    console.log(response)
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetQwilrParameterValue(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/GetQwilrParameterValue`, payLoad).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateQwilrDefinitionFieldSequence(payLoad) {
  let result = null;
  await HSuiteApiService.put(`/api/Qwilr/UpdateQwilrDefinitionFieldSequence`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetQwilrPages(generatedTag,topCount=10) {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrPages`,`?generatedTag=${generatedTag}&topCount=${topCount}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  
  return result;
}

async function AddQwilrDefinition(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddQwilrDefinition`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function DeleteQwilrDefinitionById(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/DeleteQwilrDefinitionById`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateQwilrDefinition(payLoad) {
  let result = null;
  await HSuiteApiService.put(`/api/Qwilr/UpdateQwilrDefinition`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function GetQwilrDataSources() {
  let result = null;
  await HSuiteApiService.get(`/api/Qwilr/GetQwilrDataSources`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function AddQwilrDataSource(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/AddQwilrDataSource`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function DeleteQwilrDataSourceById(payLoad) {
  let result = null;
  await HSuiteApiService.post(`/api/Qwilr/DeleteQwilrDataSourceById`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}

async function UpdateQwilrDataSource(payLoad) {
  let result = null;
  await HSuiteApiService.put(`/api/Qwilr/UpdateQwilrDataSource`, payLoad).then(response => {
    result = response;
  })
  .catch(ex => {
    console.log(ex);
    throw ex;
  })

  return result;
}
export {
  GetQwilrDefinitions, 
  GetQwilrDefinitionsByFilter,
  GetQwilrDefinitionFields,
  GetQwilrDefinitionKeyFieldsQueryModel,
  GetQwilrDefinitionFieldsByFilter,
  GetQwilrDefinitionById,
  GetBlocksFromQwilrApi,
  GetQwilrDefinitionElements,
  GetQwilrDefinitionElementsByFilter,
  AddQwilrDefinitionElement,
  DeleteQwilrDefinitionElement,
  UpdateQwilrDefinitionElement,
  GetQwilrSubstitutionMappings,
  GetQwilrSubstitutionMappingsByFilter,
  AddQwilrSubstitutionMapping,
  DeleteQwilrSubstitutionMapping,
  UpdateQwilrSubstitutionMapping,
  CreateQwilrPage,
  GetQwilrPagesByFilter,
  DeleteQwilrPage,
  AddQwilrQueryBuilder,
  GetQwilrQueryBuilderById,
  AddKeyFieldFromSqlParameter,
  AddContentFieldFormQuery,
  AddQwilrDefinitionField,
  DeleteQwilrDefinitionFieldById,
  UpdateQwilrDefinitionField,
  GetQwilrParameterValue,
  UpdateQwilrDefinitionFieldSequence,
  GetQwilrPages,
  AddQwilrDefinition,
  DeleteQwilrDefinitionById,
  UpdateQwilrDefinition,
  GetQwilrDataSources,
  AddQwilrDataSource,
  DeleteQwilrDataSourceById,
  UpdateQwilrDataSource
}